import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 3,
        rowsSize: [5, 1, 1],
        colsSize: [2, 1],
        colSpan: { "0:0": 2 },
        rowSpan: { "1:0": 2 },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/07/principle/omni-10-high-untreated.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Ten omnidirectional loudspeakers are placed above the entire audience area, operating at high sound pressure level (10 dB higher than normal) obtained by increasing the power to the loudspeakers by a factor of 10, or by choosing loudspeakers with a 10 dB higher sensitivity level.</br>No acoustic treatment has been applied in the hall. The mid-frequency reverberation time is 5.5 seconds, and the low-frequency reverberation time is 8.5 seconds.",
                    formatter: "html",
                    scrollbars: false,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    text: "dry sound",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "primary",
                    size: "large",
                    url: `${config.ASSETS_URL}/05/07/principle/dry-sound.wav`,
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    text: "sound in the hall",
                    shape: "round",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    size: "large",
                    url: `${config.ASSETS_URL}/05/07/principle/omni-10-high-untreated.wav`,
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default component;
